import axios from 'axios';
import { URL } from '../utils/Config';
import {
  clearSession,
  getFromLocalStorage,
  getUser,
  removeFromLocalStorage,
  saveInLocalStorage,
} from '../utils/Util';
import { STORAGE_KEY } from '../utils/Constant';
import { msalConfig } from '../utils/AuthConfig';

const tokenExpire = () => {
  removeFromLocalStorage(STORAGE_KEY.AUTH_DATA);
  removeFromLocalStorage(STORAGE_KEY.ITUS);
  removeFromLocalStorage(STORAGE_KEY.POWERBI);
  removeFromLocalStorage(STORAGE_KEY.KEYCLOARK);
  clearSession();
  saveInLocalStorage(STORAGE_KEY.TOKEN_EXPIRE, STORAGE_KEY.TOKEN_EXPIRE);
  window.location.href = String(msalConfig.auth.postLogoutRedirectUri);
};
const addInstance = (axiosInstance: any) => {
  axiosInstance.interceptors.response.use(
    (response: any) => {
      if (
        response.status === 401 &&
        response.config.baseURL != URL.POWERBI_API
      ) {
        tokenExpire();
      }
      return response;
    },
    (error: any) => {
      if (error.response && error.response.status === 401) {
        tokenExpire();
      }
      return Promise.reject(new Error(error));
    }
  );
};

const getAuthHeaders = (accessToken: string) => {
  const headers: any = {
    'Access-Control-Allow-Credentials': true,
    'Content-Type': 'application/json',
    'Authorization-FA': `Bearer ${accessToken}`,
  };
  return headers;
};
const getFullAuthHeaders = () => {
  const user = getUser();
  const headers: any = {
    'Access-Control-Allow-Credentials': true,
    'Content-Type': 'application/json',
    'Authorization-FA': `Bearer ${user.accessToken}`,
    authUser: user.candidateUniqueId,
  };
  return headers;
};
const getKeyCloarkAuthHeaders = () => {
  const headers: any = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  return headers;
};
const getMultipartAuthHeaders = () => {
  const user = getUser();
  const headers: any = {
    'Access-Control-Allow-Credentials': true,
    'Content-Type': 'multipart/form-data',
    'Authorization-FA': `Bearer ${user.accessToken}`,
    authUser: user.candidateUniqueId,
  };
  return headers;
};

const getPowerBIFullAuthHeaders = () => {
  const powerBiAccessToken = getFromLocalStorage(STORAGE_KEY.POWERBI);
  const headers: any = {
    'Access-Control-Allow-Credentials': true,
    'Content-Type': 'application/json',
    Authorization: `Bearer ${powerBiAccessToken}`,
  };
  return headers;
};

const getKeyCloarkFullAuthHeaders = () => {
  const keyCloarkAccessToken = getFromLocalStorage(STORAGE_KEY.KEYCLOARK);
  const headers: any = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${keyCloarkAccessToken}`,
  };
  return headers;
};

const getApiClient = (headers: any = {}, baseURL: any = URL.BASE_API_URL) => {
  const axiosInstance = axios.create({
    baseURL: baseURL ?? URL.BASE_API_URL,
    headers,
    validateStatus: (status) => {
      return status >= 200 && status < 600;
    },
  });
  addInstance(axiosInstance);
  return axiosInstance;
};
const getIAGRIApiClient = (
  headers: any = {},
  baseURL: any = URL.BASE_API_URL_IAGRI
) => {
  console.log('BASE_API_URL_IAGRI', URL.BASE_API_URL_IAGRI);
  const axiosInstance = axios.create({
    baseURL: baseURL ?? URL.BASE_API_URL_IAGRI,
    headers,
    validateStatus: (status) => {
      return status >= 200 && status < 600;
    },
  });
  addInstance(axiosInstance);
  return axiosInstance;
};

export {
  getApiClient,
  getAuthHeaders,
  getFullAuthHeaders,
  getMultipartAuthHeaders,
  getPowerBIFullAuthHeaders,
  getKeyCloarkFullAuthHeaders,
  getKeyCloarkAuthHeaders,
  getIAGRIApiClient,
};
